import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';

const clienteExternoRouteRef = createRouteRef();

const clienteExternoPage = PageBlueprint.make({
  params: {
    path: '/cliente-externo',
    title: 'Cliente externo',
    icon: <BusinessCenterIcon fontSize="inherit" />,
    noHeader: true,
    routeRef: clienteExternoRouteRef,
    loader: async () => {
      const { ClienteExternoPage } = await import('./ClienteExternoPage');
      return <ClienteExternoPage />;
    },
  },
});

export const clienteExternoPlugin = createFrontendPlugin({
  pluginId: 'cliente-externo',
  title: 'Cliente externo',
  icon: <BusinessCenterIcon fontSize="inherit" />,
  routes: {
    root: clienteExternoRouteRef,
  },
  extensions: [clienteExternoPage],
});
